import React from 'react';
import { Routes, Route } from 'react-router-dom';
import EntrepriseDashboard from '../admin/src/jsx/components/Dashboard/EntrepriseDashboard';

const EntrepriseLayout = () => {
    return (
        <div className="entreprise-layout">
            {/* Navigation Header */}
            <nav className="navbar navbar-expand-lg navbar-dark bg-primary fixed-top">
                <div className="container-fluid">
                    <a className="navbar-brand" href="#">
                        <strong>SenOffre - Espace Entreprise</strong>
                    </a>
                    <div className="navbar-nav ms-auto">
                        <a className="nav-link" href="#" onClick={() => {
                            localStorage.clear();
                            window.location.href = '/login';
                        }}>
                            <i className="fa fa-sign-out"></i> Déconnexion
                        </a>
                    </div>
                </div>
            </nav>

            {/* Main Content */}
            <div className="content-body" style={{
                marginTop: '70px',
                padding: '20px',
                minHeight: '100vh',
                backgroundColor: '#f8f9fa'
            }}>
                <div className="container-fluid">
                    <Routes>
                        <Route path="/dashboard" element={<EntrepriseDashboard />} />
                        <Route path="/*" element={<EntrepriseDashboard />} />
                    </Routes>
                </div>
            </div>
        </div>
    );
};

export default EntrepriseLayout;
